export default __webpack_public_path__ + "static/media/group-profile-img.cc0ac625.jpg";